import { boolean, object, ref, string } from 'yup';

const email = string().required().email().default('');
const password = string().required().min(3).default('');
const passwordConfirm = string()
	.required()
	.default('')
	.oneOf([ref('password'), ''], 'Passwords must match');

export const RESET_PASSWORD_VALIDATION_SCHEMA = object().shape({
	email,
});

export const APPLY_RESET_PASSWORD_VALIDATION_SCHEMA = object().shape({
	password,
	passwordConfirm,
});

export const LOGIN_VALIDATION_SCHEMA = object().shape({
	email,
	password,
	rememberMe: boolean().default(false),
});

export const REGISTER_VALIDATION_SCHEMA = object().shape({
	name: string().trim().required().min(1).max(100),
	email,
	password,
	passwordConfirm,
});
